// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3rsr_","info":"UpdateTermsInfo_info__3h6n1"};